import Marquee from 'react-fast-marquee';
import { Link } from 'react-router';

import Reveal, { Delay } from '@cartwhl/ui/atoms/Reveal';
import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';

import GreenLink from 'components/GreenLink';
import { CDN } from 'consts';

import TeamMember from './TeamMember';

const teamMembers = [
  {
    name: 'Jonathan Jarvis',
    position: 'Co-founder & CEO',
    image: { src: '/images/company/Jarvis.webp', alt: 'Jonathan Jarvis' },
  },
  {
    name: 'Andrew Carr',
    position: 'Co-founder & Chief Scientist',
    image: { src: '/images/company/Andrew.webp', alt: 'Andrew Carr' },
  },
  {
    name: 'Gabi Marquez',
    position: 'VP, Product & GTM Strategy',
    image: { src: '/images/company/Gabi.webp', alt: 'Gabi Marquez' },
  },
  {
    name: 'Mitch Probst',
    position: 'Lead Engineer',
    image: { src: '/images/company/Mitch.webp', alt: 'Mitch Probst' },
  },
  {
    name: 'Buthaina Mahmoud',
    position: 'Lead Animation Engineer',
    image: { src: '/images/company/Buthaina.webp', alt: 'Buthaina Mahmoud' },
  },
  {
    name: 'Katie Lowen',
    position: 'Lead Data Engineer',
    image: { src: '/images/company/Katie.webp', alt: 'Katie Lowen' },
  },
  {
    name: 'Joakim Olsson',
    position: 'Principal Research Scientist',
    image: { src: '/images/company/Joakim.webp', alt: 'Joakim Olsson' },
  },
  {
    name: 'Steven Ziadie',
    position: 'Design Lead',
    image: { src: '/images/company/Steven.webp', alt: 'Steven Ziadie' },
  },
  {
    name: 'Neil Helm',
    position: 'Animation Lead',
    image: { src: '/images/company/Neil.webp', alt: 'Neil Helm' },
  },
  {
    name: 'Donald Chan',
    position: 'Animation Lead',
    image: { src: '/images/company/Donald.webp', alt: 'Donald Chan' },
  },
  {
    name: 'Phillip Mason',
    position: 'Engineer',
    image: { src: '/images/company/Phillip2.webp', alt: 'Phillip Mason' },
  },
  {
    name: 'Alex Krainin',
    position: 'Head of Strategy and Operations',
    image: { src: '/images/company/Alex.webp', alt: 'Alex Krainin' },
  },
  {
    name: 'Vaniya Agrawal',
    position: 'Senior Full-Stack Engineer',
    image: { src: '/images/company/Vaniya.webp', alt: 'Vaniya Agrawal' },
  },
  {
    name: 'Aalok Patwardhan',
    position: 'Lead Research Scientist - Computer Vision',
    image: { src: '/images/company/Aalok.webp', alt: 'Aalok' },
  },
  {
    name: 'Sven Schmidt',
    position: 'Senior Frontend Engineer',
    image: { src: '/images/company/Sven.webp', alt: 'Sven Schmidt' },
  },
  {
    name: 'Levi Harrison',
    position: 'Full-Stack Engineer',
    image: { src: '/images/company/Levi.webp', alt: 'Levi Harrison' },
  },
  {
    name: 'Param Hanji',
    position: 'Lead Research Scientist - Generative Vision',
    image: { src: '/images/company/Param.webp', alt: 'Param Hanji' },
  },
  {
    name: 'Matthias Plappert',
    position: 'Advisor',
    image: { src: '/images/company/Matthias.webp', alt: 'Matthias Plappert' },
  },
  {
    name: 'Emiliano Gambaretto',
    position: 'Advisor',
    image: { src: '/images/company/Emiliano.webp', alt: 'Emiliano' },
  },
];

const investors = [
  'MVP',
  'Pelion',
  'Accel',
  'Khosla',
  'Human Ventures',
  'Heretic',
  'Correlation Ventures',
];

const openRoles: { title: string; href: string }[] = [
  // hide for now, the copy of it would need to be reworded
  // {
  //   title: 'Founding Marketing Lead',
  //   href: '/careers/founding-marketing-lead',
  // },
];

export { openRoles };

export default function CompanyPage() {
  return (
    <main>
      {/* Hero Section */}
      <div className="container lg:mb-[106px]">
        <Text
          as="h1"
          variant="web/display/2xl"
          lg:variant="web/display/3xl"
          className="mt-16 lg:mt-[80px]"
        >
          We're an <span className="text-green-50">AI lab</span> focused on{' '}
          <span className="text-green-50">movement</span> as a first class data
          structure.
          <br />
          <br />
          We train foundation models that are integrated deeply into our
          products and your pipelines.
        </Text>

        <Reveal delay="200" transition="slide">
          <Text
            as="p"
            variant="web/body/medium/lg"
            lg:variant="web/body/medium/xl"
            className="mb-[64px] mt-[69px] lg:mb-[138px] lg:mt-32"
          >
            We’re a team of artists, engineers, and scientists focused on making{' '}
            <br />
            motion editable, reusable, controllable and scalable in production.
          </Text>
        </Reveal>

        {/* Team Grid */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4 md:gap-4">
          {teamMembers.map((member, index) => (
            <Reveal
              key={member.name}
              delay={((index % 4) * 100) as unknown as Delay}
            >
              <TeamMember
                name={member.name}
                position={member.position}
                image={member.image}
              />
            </Reveal>
          ))}
        </div>
      </div>

      {/* Investors Marquee */}
      <Reveal className="mb-20 mt-16 w-full overflow-x-hidden lg:mb-32 lg:mt-[272px]">
        <Text
          as="h2"
          variant="web/body/medium/lg"
          className="container mb-20 lg:mb-32"
        >
          Backed by some of the best
        </Text>
        <Marquee autoFill direction="right">
          <div className="flex items-center gap-20 pr-20">
            {investors.map((name) => (
              <Text key={name} variant="web/display/2xl">
                {name}
              </Text>
            ))}
            <img
              className="h-16 md:h-24"
              src="/images/company/cartwheel_forward.gif"
              alt="Spinning Cartwheel logo"
            />
          </div>
        </Marquee>
        <div className="mt-10 md:hidden">
          <Marquee autoFill direction="left">
            <div className="flex items-center gap-20 pr-20">
              {investors.map((name) => (
                <Text key={`left-${name}`} variant="web/display/2xl">
                  {name}
                </Text>
              ))}
              <img
                className="h-16 md:h-24"
                src="/images/company/cartwheel_backward.gif"
                alt="Spinning Cartwheel logo"
              />
            </div>
          </Marquee>
        </div>
      </Reveal>

      {/* Careers Section */}
      <div className="mb-32 md:mb-56">
        <Reveal>
          <Video
            className="relative block h-[200px] w-full overflow-hidden md:h-[360px] xl:h-[500px]"
            src={`${CDN}Ambient_Videos_Part3.mp4`}
            mode="autoplay"
            contained={true}
          />
        </Reveal>

        <Reveal>
          <Text
            as="h2"
            variant="web/display/2xl"
            lg:variant="web/display/3xl"
            className="container mb-5"
          >
            Careers
          </Text>
        </Reveal>

        <Reveal delay="100">
          <section className="container mb-20 mt-[60px] flex flex-col items-start gap-6 lg:mb-[134px] lg:mt-[120px] lg:gap-[44px]">
            <Text
              as="p"
              variant="web/body/medium/lg"
              lg:variant="web/body/medium/xl"
              className="max-w-[484px] lg:max-w-[1064px]"
            >
              We're a small, fully-distributed team, and we're actively hiring!
              <br />
              <br />
              Come help us build the future of motion for games, film, robotics,
              and embodied systems. We offer competitive compensation and
              meaningful ownership in the work. If you think you can contribute,
              we’d love to hear from you.
            </Text>
            <GreenLink href="mailto:contact@getcartwheel.com">
              Contact us
            </GreenLink>
          </section>
        </Reveal>

        {/* Open Roles */}
        <Reveal>
          <div className="container mt-[-18px]">
            <div className="text-gray-45 flex h-14 items-center">
              <Text variant="web/body/medium/md">Roles</Text>
            </div>
            {openRoles.length === 0 ? (
              <div className="border-gray-30 flex h-14 items-center border-t">
                <Text variant="web/body/medium/md" className="text-tertiary">
                  There are currently no roles posted.
                </Text>
              </div>
            ) : (
              openRoles.map((role) => (
                <Link
                  key={role.href}
                  to={role.href}
                  className="border-gray-30 dark:hover:text-gray-90 flex h-14 items-center border-t font-normal transition-all last:border-y hover:bg-[#E9FDE7]"
                >
                  <Text variant="web/body/medium/md">{role.title}</Text>
                </Link>
              ))
            )}
          </div>
        </Reveal>
      </div>
    </main>
  );
}
